import { Component, computed, inject, signal } from '@angular/core';
import { TablePaginationComponent } from '../../../../shared/common';
import { Router } from '@angular/router';
import { ProductLibrarayService } from '../../services/product-libraray.service';
import { ProductDTO } from '../../interface/product-library.entity';
import { ModalService } from '../../../../shared/services/modal.service';
import { NotificationService, DotLoadingServices } from '../../../../core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";

@Component({
  selector: 'app-product-library-view',
  imports: [
    TablePaginationComponent,
    CommonModule,
    FormsModule
],
  templateUrl: './product-library-view.html',
  styleUrl: './product-library-view.scss'
})
export class ProductLibraryView {

  protected router = inject(Router);
  protected productLibraryService = inject(ProductLibrarayService);
  protected modal = inject(ModalService);
  protected notification = inject(NotificationService);
  private loading = inject(DotLoadingServices);

  totalItems = signal<number>(0);
  pageNumber = signal<number>(1);
  itemsPerPage = signal<number>(10);
  products = signal<ProductDTO[]>([]);
  selectedProduct = signal<ProductDTO | null>(null);
  generalData = computed(() => this.selectedProduct()?.generalData);
  technicalData = computed(() => this.selectedProduct()?.technicalData?.[0]);
  finishings = computed(() => this.selectedProduct()?.finishings ?? []);
  department = computed(() => this.selectedProduct()?.department);

  protected searchParams = signal({
    pageNumber: 1,
    itemsPerPage: 10,
    customerProductCode: '',
    productCode: '',
    productName: '',
    customer: ''
  });

  ngOnInit() {
    this.getAllProducts();
  }

  public onPageChange(pageNumber: number): void {
    const updatedParams = {
        ...this.searchParams(),
        pageNumber: Number(pageNumber)
    };
    this.searchParams.set(updatedParams);
    this.getAllProducts();
  }

  createProduct() {
    this.router.navigate(['product-library-create']).then(r => r);
  }

  getAllProducts() {
    const current = this.searchParams();

    const params = {
      pageNumber: current.pageNumber,
      itemsPerPage: current.itemsPerPage,
      customerProductCode: current.customerProductCode,
      productCode: current.productCode,
      productName: current.productName,
      customer: current.customer,
    };

    this.loading.set(true);
    this.productLibraryService.getAllProducts(params).subscribe({
      next: (res) => {
        const response = res.data;

        this.products.set(response.data);
        this.totalItems.set(response.pagination.totalItems);
        this.pageNumber.set(response.pagination.pageNumber);
        this.itemsPerPage.set(response.pagination.itemsPerPage);
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Failed to fetch products', err);
        this.loading.set(false);
      }
    });
  }

  openFileUploadModal() {
    this.modal.$$showExelUploadModal.set(true);
  }

  openProcductViewModal(productCode: string) {
    this.modal.$$showProcductViewModal.set(true);
    console.log(productCode);
    this.getProductGetByCode(productCode);
    
  }

  closeFileUploadModal() {
    this.modal.$$showExelUploadModal.set(false);
  }

  closeProcductViewModal() {
    this.modal.$$showProcductViewModal.set(false);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {

      const fileType = file.name.split('.').pop()?.toLowerCase();
      if (fileType === 'xlsx' || fileType === 'xls') {
        this.productLibraryService.uploadproductExcel(file).subscribe({
          next: (res) => {
              this.notification.set({type: 'success', message: `Product saved successfully.`});
              this.modal.$$showExelUploadModal.set(false);
            },
            error: (err) => {
              this.notification.set({type: 'error', message: `Product saved Failed.`});
              this.modal.$$showExelUploadModal.set(false);
            }
        })
      } else {
        this.notification.set({type: 'error', message: `Invalid file type. Only .xlsx and .xlsfiles are allowed.`});
      }
    }
  }

  getProductGetByCode(prodCode: string) {
    this.loading.set(true);
    this.productLibraryService.getProductById(prodCode).subscribe({
      next: (res) => {
        this.selectedProduct.set(res.data);
        // console.log('Product:', this.selectedProduct());
        this.loading.set(false);
      },
      error: (err) => {
        console.error('Failed to fetch product by ID', err);
        this.loading.set(false);
      }
    });
  }

  openProductEdit(prodCode: string) {
    this.router.navigate(['product-library-create'], {
      queryParams: { code: prodCode, mode: 'edit' }
    });
  }


}
